import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const createAccountAction = {
    ...operations,
    ...selectors,
};

export {
    createAccountAction,
};
export default {
    [namespace]: reducer,
};
